'use client';

import { TrackedErrorPage } from '@/components/Page/TrackedErrorPage';

export default function NotFound() {
  return <TrackedErrorPage statusCode={404} />;
}
